/**
 * Narwhalia backend
 * Swagger API docs for Narwhalia Backend application
 *
 * OpenAPI spec version: 0.9
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export class OfferDto {
	constructor(
	/** Start price of the offer */
	public startPrice: number,
	/** End price of the offer */
	public endPrice: number,
	/** Period of the offer in minutes */
	public period: number){}
}